// "Powered by <product> - <version> - <vendor>" (STAGE_7 7.7): at the foot of the
// interface and of the rating page. No setting turns it off.

import { Typography } from 'antd';

import { useAppConfig } from '@/features/config/configContext';
import { ru } from '@/i18n/ru';

export function PoweredBy({ lang = 'ru' }: { lang?: 'ru' | 'uz' }) {
  const config = useAppConfig();
  const say = lang === 'uz' ? ru.app.poweredByUz : ru.app.poweredBy;
  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }} data-testid="powered-by">
      {say(config.product_name, config.version, config.vendor_name)}
    </Typography.Text>
  );
}
